export default "__VITE_ASSET__BCJl4EBB__"